'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _reactRedux = require('react-redux');

var _utils = require('../utils');

var _reducers = require('../reducers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var omitPropNames = ['baseURL', 'staticContext', 'permission', 'permissions', 'moduleCode', 'functionCode', 'actionCode', 'functionCodes', 'actionCodes', 'redirectUrl', 'urlRedirector', 'propNamespace', 'isInitialized', 'initialize', 'destory', 'fetchUserPermissions', 'createPagePermission'];

var mapStateToProps = function mapStateToProps(state) {
  (0, _utils.validatePermissionReducer)(state.permission);
  return state.permission || {};
};
var mapDispatchToProps = {
  initialize: _reducers.initialize,
  destory: _reducers.destory,
  fetchUserPermissions: _reducers.fetchUserPermissions,
  createPagePermission: _reducers.createPagePermission
};

var defaultConfig = {
  // 設定permission名稱
  permission: undefined,
  // 設定目前模組,提供給getUserPermissions作為query參數
  moduleCode: undefined,
  // 設定允許功能,提供給getUserPermissions作為query參數
  functionCode: undefined,
  // 設定允許動作
  actionCode: undefined,
  // 設定允許多筆功能
  // [
  //   {
  //     functionCode,
  //     actionCode,
  //   }
  // ]
  functionCodes: undefined,
  // 注入到component的prop名稱
  propNamespace: undefined,
  // 設定 domain url
  baseURL: undefined
};

var withPermission = function withPermission() {
  var initialConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var config = Object.assign({}, defaultConfig, initialConfig);

  return function (WrappedComponent) {
    var WithPermission = function (_Component) {
      _inherits(WithPermission, _Component);

      _createClass(WithPermission, null, [{
        key: 'validator',
        value: function validator() {
          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              permission = _ref.permission,
              functionCode = _ref.functionCode,
              actionCode = _ref.actionCode,
              functionCodes = _ref.functionCodes,
              propNamespace = _ref.propNamespace,
              baseURL = _ref.baseURL;

          (0, _utils.validatePermission)(permission);
          (0, _utils.validatePropNamespace)(propNamespace);
          if (!functionCode && (!functionCodes || !(0, _lodash.isArray)(functionCodes))) {
            (0, _utils.error)('Missing parameter. FunctionCode or functionCodes is required');
          } else if (functionCode && typeof functionCode !== 'string') {
            (0, _utils.error)('FunctionCode must be a string. If you want to allow multiple permissions. Use functionCodes');
          } else if (functionCodes && !(0, _lodash.isArray)(functionCodes)) {
            (0, _utils.error)('FunctionCodes must be an array');
          }
          (0, _utils.validateActionCode)(actionCode);
          // validate functionCodes
          if (functionCodes) {
            functionCodes.forEach(function (item) {
              if (!item.functionCode) {
                (0, _utils.error)('Missing parameter. FunctionCode is required');
              }
              if (typeof item.functionCode !== 'string') {
                (0, _utils.error)('FunctionCode must be a string');
              }
              (0, _utils.validateActionCode)(item.actionCode);
            });
          }
          (0, _utils.validatebaseURL)(baseURL);
        }
      }, {
        key: 'propTypes',
        get: function get() {
          return {
            allPermissions: _propTypes2.default.array,
            moduleCode: _propTypes2.default.string,
            functionCode: _propTypes2.default.string,
            permission: _propTypes2.default.string,
            initialize: _propTypes2.default.func,
            destory: _propTypes2.default.func,
            fetchUserPermissions: _propTypes2.default.func,
            createPagePermission: _propTypes2.default.func,
            baseURL: _propTypes2.default.string
          };
        }
      }, {
        key: 'childContextTypes',
        get: function get() {
          return {
            _userPermissions: _propTypes2.default.shape({
              permissionFailRedirector: _propTypes2.default.func,
              isActionAllowed: _propTypes2.default.func,
              isActionDenied: _propTypes2.default.func
            })
          };
        }
      }]);

      function WithPermission() {
        _classCallCheck(this, WithPermission);

        var _this = _possibleConstructorReturn(this, (WithPermission.__proto__ || Object.getPrototypeOf(WithPermission)).call(this));

        ['getPermissions', 'getPassedPermissions', 'isActionAllowed', 'isActionDenied', 'permissionFailRedirector'].forEach(function (fn) {
          _this[fn] = _this[fn].bind(_this);
        });
        return _this;
      }

      _createClass(WithPermission, [{
        key: 'getChildContext',
        value: function getChildContext() {
          return {
            _userPermissions: {
              permissionFailRedirector: this.permissionFailRedirector,
              isActionAllowed: this.isActionAllowed,
              isActionDenied: this.isActionDenied
            }
          };
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          // 驗證來源config
          WithPermission.validator(config);
          // 初始化config
          this.props.initialize(config);
          // 取得權限資料
          var _props = this.props,
              moduleCode = _props.moduleCode,
              functionCode = _props.functionCode,
              permission = _props.permission,
              baseURL = _props.baseURL,
              allPermissions = _props.allPermissions;

          var params = {
            moduleCode: moduleCode,
            functionCode: functionCode
          };

          if (allPermissions) {
            this.props.createPagePermission(permission);
          } else {
            this.props.fetchUserPermissions(baseURL, params).then(function () {
              return _this2.props.createPagePermission(permission);
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.props.destory(this.props.permission);
        }
      }, {
        key: 'getPermissions',
        value: function getPermissions() {
          var permission = this.props.permission;
          var permissions = this.props[permission].permissions;

          return permissions || [];
        }
      }, {
        key: 'getPassedPermissions',
        value: function getPassedPermissions(functionCode, actionCode) {
          var permissions = this.getPermissions();
          var functionCodes = (0, _utils.toArray)(functionCode);
          var passedPermissions = permissions.filter(function (item) {
            return (0, _utils.getFnCode)(item, functionCodes);
          });
          if (actionCode) {
            var actionCodes = (0, _utils.toArray)(actionCode);
            passedPermissions = passedPermissions.filter(function (item) {
              return (0, _utils.getActionCode)(item, actionCodes);
            });
          }
          return (0, _utils.isContainArray)(permissions) && passedPermissions;
        }
      }, {
        key: 'isActionAllowed',
        value: function isActionAllowed(functionCode, actionCode) {
          (0, _utils.validateFunctionCode)(functionCode);
          var passedPermissions = this.getPassedPermissions(functionCode, actionCode);
          return passedPermissions.length > 0;
        }
      }, {
        key: 'isActionDenied',
        value: function isActionDenied(functionCode, actionCode) {
          return !this.isActionAllowed(functionCode, actionCode);
        }
      }, {
        key: 'permissionFailRedirector',
        value: function permissionFailRedirector(allowedFunctionCode, allowedActionCode, redirector) {
          if (allowedFunctionCode && this.isActionAllowed(allowedFunctionCode, allowedActionCode)) {
            return false;
          }

          // 如果有設定allowedFunctionCode，以設定的allowedFunctionCode為主要判斷
          // 就算Config有設其他FunctionCode，只要沒有allowedFunctionCode的權限就會導頁
          if (!allowedFunctionCode && this.getPermissions().length !== 0) {
            return false;
          }

          if (typeof redirector === 'function') {
            return redirector();
          }

          if (typeof redirector !== 'string') {
            return false;
          }
          return function () {
            window.location.href = redirector;
          }();
        }
      }, {
        key: 'render',
        value: function render() {
          var permission = this.props.permission;

          var _ref2 = this.props[permission] || {},
              isInitialized = _ref2.isInitialized,
              propNamespace = _ref2.propNamespace,
              actionCodes = _ref2.actionCodes,
              functionCodes = _ref2.functionCodes,
              permissions = _ref2.permissions;

          omitPropNames.push(permission);
          var childProps = (0, _lodash.omit)(this.props, omitPropNames);
          var componentProps = Object.assign({}, childProps, _defineProperty({}, propNamespace, {
            actionCodes: actionCodes,
            functionCodes: functionCodes,
            isActionAllowed: this.isActionAllowed,
            isActionDenied: this.isActionDenied,
            permissionFailRedirector: this.permissionFailRedirector
          }));
          return isInitialized && permissions ? _react2.default.createElement(WrappedComponent, componentProps) : null;
        }
      }]);

      return WithPermission;
    }(_react.Component);

    WithPermission.displayName = 'withPermission(' + (_react.Component.displayName || _react.Component.name) + ')';

    var ConnectedPermission = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WithPermission);
    ConnectedPermission.defaultProps = config;
    return ConnectedPermission;
  };
};

exports.default = withPermission;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/user-permissions/lib/components/withPermission.js
 ** module id = 258
 ** module chunks = 0
 **/